module.exports = __webpack_public_path__ + "img/swap.3488ce17.svg";